import gql from 'graphql-tag';

const accountMarketingMaterialCreate = gql`
  mutation accountMarketingMaterialCreate(
    $input: AccountMarketingMaterialCreateInput!
  ) {
    accountMarketingMaterialCreate(input: $input) {
      account_marketing_material {
        id
      }
    }
  }
`;

export default accountMarketingMaterialCreate;
